module.exports = __webpack_public_path__ + "static/media/F8HIDylawAATCPp.d2b63fc5.webp";